export default [
  {
    id: 1,
    title: '如何把網路聲量變選票？',
    subtitle: '選戰倒數',
    description: '根據《DailyView 網路溫度計》分析，國民黨總統參選人韓國瑜的網路聲量是總統蔡英文的2倍，但民調結果卻完全相反，為什麼？網路上的高熱度，又該如何轉成選票？讓專家來告訴你。',
    image: require('@/assets/articles/article-1-cover.jpg'),
    url: 'https://topic.udn.com/event/election2020_socialmedia'
  },
  {
    id: 2,
    title: '選民如何看懂民調？',
    subtitle: '民調可信嗎',
    description: '總統蔡英文曾說：「民調是死的，人心是活的。」高雄市長韓國瑜說：「執政要在乎熱呼呼的民心，關心民調幹嘛？」看似對民調雲淡風輕，但隨投票日逐漸逼近，選情愈來愈緊繃，這些滿天飛的民調又該怎麼看？有多少可信度？',
    image: require('@/assets/articles/article-2-cover.jpg'),
    url: 'https://topic.udn.com/event/election2020_poll'
  },
  {
    id: 3,
    title: '7大秘訣教你看懂民調',
    subtitle: '選前攻略！',
    description: '民調準不準的關鍵是什麼？具備哪些要素才是合格民調？大選倒數50天，選前每隔幾天就有一次民調發布，讓選民霧煞煞，也容易影響選情。專家條列7大秘訣，魔鬼藏在細節裡，一次看懂民調數字沒說的事。',
    image: require('@/assets/articles/article-3-cover.jpg'),
    url: 'https://topic.udn.com/event/election2020_pollQA'
  }
]
